import _ from 'lodash'
import 'materialize-css'
import moment from 'moment'
import {flare} from '@flareapp/flare-client'
import flatpickr from 'flatpickr'
import {French} from 'flatpickr/dist/l10n/fr.js'
import 'trix/dist/trix'

import './vue'
import 'select2'
import sortable from 'html5sortable/dist/html5sortable.es'
import './polyfills'

import {trans} from './setup/locales'

import axios from './setup/axios'
import {showAlert, showLoading} from './helpers'
import './distribution_screen.js'
import './recipe_materials_sortable.js'

window._ = _

window.$ = window.jQuery = require('jquery')

moment.locale('fr')
window.moment = moment

/* global FLARE_APP_API_KEY */
const flareAppApiKey = FLARE_APP_API_KEY // FLARE_APP_API_KEY is defined on webpack.mix.js
if (flareAppApiKey !== '') {
  flare.light(flareAppApiKey)
}

document.addEventListener('DOMContentLoaded', () => {
  const deleteFormElements = document.querySelectorAll('.delete-form')
  if (deleteFormElements.length > 0) {
    Array.from(deleteFormElements).forEach(element => {
      element.addEventListener('submit', event => {
        const message = event.currentTarget.dataset.deleteConfirm
        if (confirm(message)) {
          showLoading(true)
          return true
        }

        event.preventDefault()
      })
    })
  }

  const confirmSubmitFormElements = document.querySelectorAll('form.confirm-submit')
  if (confirmSubmitFormElements.length > 0) {
    Array.from(confirmSubmitFormElements).forEach(element => {
      element.addEventListener('submit', event => {
        const message = event.currentTarget.dataset.confirmSubmitMsg
        if (confirm(message)) {
          showLoading(true)
          return true
        }

        event.preventDefault()
      })
    })
  }

  const orderProductQty = document.querySelectorAll('#order_products_qty')
  if (orderProductQty.length > 0) {
    initCalculateProductTotalPrice(orderProductQty)
  }

  // calendrier des congés
  const holydayCalendar = document.querySelector('#no-order-dates')

  if (holydayCalendar !== null) {

    let datesAlert = []

    let today = moment()
    let todayEndOfDay = moment(today)
      .utcOffset(window.timeOffsetMinutes)
      .endOf('day')
      .local()

    let todayMaxOrderTime = moment(today)
      .utcOffset(window.timeOffsetMinutes)
      .startOf('day')
      .set('hour', window.maxOrderTimeH).set('minute', window.maxOrderTimeM)
      .local()

    let jPlusDeux = moment(today)
      .utcOffset(window.timeOffsetMinutes)
      .add(2, 'days')
      .startOf('day')
      .local()

    let isJPlusDeuxInitiallySelected = window.selectedDates.indexOf(jPlusDeux.format('YYYY-MM-DD')) >= 0
    let jPlusDeuxEnabled = true

    const iniCheckFlatpickr = function(flatpickrInstance) {
      checkFlatpickr(flatpickrInstance)
      let intervalID = setInterval(checkFlatpickr, 1000, flatpickrInstance)
    }

    const checkFlatpickr = function(flatpickrInstance) {
      if (moment().isAfter(todayEndOfDay)) {
        alert(`${trans('holidays.warning.page_reload')}`)
        location.reload()
      }

      if (jPlusDeuxEnabled) {
        if (moment().isSameOrAfter(todayMaxOrderTime)) {
          jPlusDeuxEnabled = false
          resetjPlusDeux(flatpickrInstance)
        }
      }
    }

    const resetjPlusDeux = function(flatpickrInstance) {
      if (!jPlusDeuxEnabled) {
        let isJPlusDeuxSelected = flatpickrInstance.selectedDates.filter(
          date => moment(date).format('YYYY-MM-DD') === jPlusDeux.format('YYYY-MM-DD')
        ).length > 0

        if (isJPlusDeuxSelected !== isJPlusDeuxInitiallySelected) { // si la valeur a été modifiée
          let newSelectedDates = []

          if (isJPlusDeuxInitiallySelected) { // si initialement sélectionné, alors on doit la re-sélectionner
            newSelectedDates = flatpickrInstance.selectedDates
            newSelectedDates.push(jPlusDeux.toDate())
          }
          else { // si initialement pas sélectionné, alors on doit la dé-sélectionner
            newSelectedDates = flatpickrInstance.selectedDates.filter(
              date => moment(date).format('YYYY-MM-DD') !== jPlusDeux.format('YYYY-MM-DD')
            )
          }

          flatpickrInstance.setDate(newSelectedDates)

          alert(
            `${trans('holidays.warning.disabled_and_reset')}`.replace(
              /:date/,
              jPlusDeux.format('dddd Do MMMM YYYY')
            ).replace(
              /:maxOrderTime/,
              window.maxOrderTime
            )
          )
        }
      }
    }

    flatpickr(holydayCalendar, {
      inline: true,
      mode: 'multiple',
      dateFormat: 'Y-m-d',
      locale: French,
      disable: [
        function(date) {
          // return true to disable
          return window.holidayDays.indexOf(date.getDay()) === -1
        },
      ],
      minDate: jPlusDeux.toDate(),
      // on ne peut pas toucher au congé du jour même ni de J+1 car les commande sont déjà traitées jusqu'à J+1.
      defaultDate: window.selectedDates,
      onReady: function(selectedDates, dateStr, instance) {
        const select = document.querySelector('.flatpickr-monthDropdown-months')
        if (select) {
          select.classList.add('browser-default')
        }
        const input = document.querySelector('.numInput')
        if (input) {
          input.classList.add('browser-default')
        }
        instance.jumpToDate(new Date(), false)

        iniCheckFlatpickr(instance)
      },
      onChange: function(selectedDates, dateStr, instance) {
        resetjPlusDeux(instance)

        if (typeof window.orders === 'undefined') {
          return
        }

        const orders = window.orders

        if (Object.keys(orders).length > 0 && selectedDates.length >= 0) {
          let datesToRemove = []

          const message = selectedDates
            .map(date => {
              const formattedDate = moment(date).format('YYYY-MM-DD')
              const displayDate = moment(date).format('dddd Do MMMM YYYY')

              if (!jPlusDeuxEnabled && formattedDate == jPlusDeux.format('YYYY-MM-DD')) {
                return null
              }

              if (typeof orders[formattedDate] !== 'undefined') {
                if (datesAlert.indexOf(formattedDate) < 0) {
                  datesAlert.push(formattedDate)

                  if (orders[formattedDate] === 'process_pending') {
                    return `${trans('holidays.warning.pending_order')}`.replace(
                      /:date/,
                      displayDate
                    )
                  }
                  else if (orders[formattedDate] === 'not_processed') {
                    datesToRemove.push(formattedDate)
                    return `${trans('holidays.warning.not_processed_order')}`.replace(
                      /:date/,
                      displayDate
                    )
                  }
                  else {
                    datesToRemove.push(formattedDate)
                    return `${trans('holidays.warning.processing_order')}`.replace(
                      /:date/,
                      displayDate
                    )
                  }
                }
              }

              return null
            })
            .filter(str => str !== null)

          if (datesToRemove.length > 0) {
            let newSelectedDates = []

            selectedDates.forEach(function(date) {
              if (datesToRemove.indexOf(moment(date).format('YYYY-MM-DD')) < 0) {
                newSelectedDates.push(date)
              }
            })

            instance.setDate(newSelectedDates)
            selectedDates = newSelectedDates
          }

          datesAlert = []
          selectedDates.forEach(function(date) {
            datesAlert.push(moment(date).format('YYYY-MM-DD'))
          })

          if (message.length > 0) {
            alert(message.join('\n'))
          }
        }
      },
    })
  }

  if (document.querySelectorAll('.datepick').length > 0) {
    const {minDate, maxDate, disableDates, onDateChange} = window

    let options = {
      locale: French,
      dateFormat: 'Y-m-d',
      altInput: true,
      altFormat: 'd/m/Y',
      onReady: function(selectedDates, dateStr, instance) {
        instance.monthElements.forEach(element =>
          element.classList.add('browser-default')
        )
        instance.yearElements.forEach(element =>
          element.classList.add('browser-default')
        )
      },
    }
    if (typeof onDateChange !== 'undefined') {
      options.onChange = onDateChange
    }
    if (typeof minDate !== 'undefined') {
      options.minDate = minDate
    }
    if (typeof maxDate !== 'undefined') {
      options.maxDate = maxDate
    }
    if (typeof disableDates !== 'undefined') {
      options.disable = disableDates
    }
    flatpickr('.datepick', options)
  }

  $('#new-order-form').submit(function() {
    const orderDate = moment($('#delivery_date').val())
    if (!orderDate.isValid()) {
      return false
    }

    const orderDateFormatted = orderDate.format('dddd, MMMM Do YYYY')
    if (
      confirm(
        `${trans('orders.creation_confirm')}`.replace(
          /:date/,
          orderDateFormatted
        )
      )
    ) {
      showLoading(true)
      $('#new-order-form')
        .get(0)
        .submit()
    }
    return false
  })

  // select 2
  $('.select2select').each(function() {
    let options = {
      width: '100%',
    }
    if ($(this).hasClass('select2select-no_searchbox')) {
      options.minimumResultsForSearch = Infinity
    }

    $(this).select2(options)
  })

  initSortableCmde()

  initClient()

  initVehicleChoiceForm()

  initMaterialize()

  initRecipeForm()
})

const initMaterialize = function() {
  let registry = {
    //Autocomplete: document.querySelectorAll('.autocomplete:not(.no-autoinit)'),
    //Carousel: document.querySelectorAll('.carousel:not(.no-autoinit)'),
    //Chips: document.querySelectorAll('.chips:not(.no-autoinit)'),
    Collapsible: document.querySelectorAll('.collapsible:not(.no-autoinit)'),
    //Datepicker: document.querySelectorAll('.datepicker:not(.no-autoinit)'),
    //Dropdown: document.querySelectorAll('.dropdown-trigger:not(.no-autoinit)'),
    //Materialbox: document.querySelectorAll('.materialboxed:not(.no-autoinit)'),
    Modal: document.querySelectorAll('.modal:not(.no-autoinit)'),
    //Parallax: document.querySelectorAll('.parallax:not(.no-autoinit)'),
    //Pushpin: document.querySelectorAll('.pushpin:not(.no-autoinit)'),
    //ScrollSpy: document.querySelectorAll('.scrollspy:not(.no-autoinit)'),
    FormSelect: document.querySelectorAll(
      'select:not(.no-autoinit):not(.select2select):not(.browser-default)'
    ),
    Sidenav: document.querySelectorAll('.sidenav:not(.no-autoinit)'),
    Tabs: document.querySelectorAll('.tabs:not(.no-autoinit)'),
    //TapTarget: document.querySelectorAll('.tap-target:not(.no-autoinit)'),
    //Timepicker: document.querySelectorAll('.timepicker:not(.no-autoinit)'),
    Tooltip: document.querySelectorAll('.tooltipped:not(.no-autoinit)'),
    //FloatingActionButton: document.querySelectorAll('.fixed-action-btn:not(.no-autoinit)')
  }

  for (let pluginName in registry) {
    // eslint-disable-next-line no-undef
    const plugin = M[pluginName]
    if (plugin) {
      plugin.init(registry[pluginName])
    }
  }
}

const calculateProductTotalPrice = element => {
  const productId = element.dataset.productId
  const productUnitPrice = element.dataset.productUnitPrice
  const qty = parseInt(element.value)
  const totalPrice = qty * productUnitPrice
  const totalPriceRound = Math.round(totalPrice * 100) / 100

  const priceElement = document.querySelector(
    `#order_products_qty #product_total_price_${productId}`
  )
  if (priceElement !== null) {
    priceElement.innerHTML = totalPriceRound.toFixed(2)
  }
}

const initCalculateProductTotalPrice = function(orderProductQty) {
  Array.from(orderProductQty).forEach(element => {
    calculateProductTotalPrice(element)
    element.addEventListener('keyup', event =>
      calculateProductTotalPrice(event.target)
    )
  })
}

const initSortableCmde = () => {
  const elements = document.querySelectorAll('ol.cmde_page')
  if (elements.length > 0) {
    Array.from(elements).forEach(element => {
      sortable(element, {
        acceptFrom: '.cmde_page',
        pullPlaceholder: false,
        forcePlaceholderSize: true,
        itemSerializer: serializedItem => {
          return {
            position: serializedItem.index,
            id: Number(serializedItem.node.dataset.id),
          }
        },
      })[0].addEventListener('sortupdate', async event => {
        await updateCmdeRecipe('stop', element, $(event.detail.item))
      })
    })
  }
}

const updateCmdeRecipe = async (event, parent, $item) => {
  const parent_page = parent.dataset.page
  const $new_parent = $item.parent('ol.cmde_page')
  const item_page = $new_parent.data('page')

  const pages = [parent_page]
  if (item_page !== parent_page) {
    pages.push(item_page)
  }

  let data = {}
  pages.forEach(function(item) {
    const [serializable] = sortable(
      `ol.cmde_page[data-page="${item}"]`,
      'serialize'
    )
    data[item] = serializable.items
  })

  showLoading(true)

  await axios.post($('#pages').data('url'), {pages: data})
  showLoading(false)
}

const addNewCmdePage = document.querySelector('#add_new_cmde_page')
if (addNewCmdePage !== null) {
  addNewCmdePage.addEventListener('click', e => {
    e.preventDefault()

    const parent = document.querySelector('#pages')
    const pages = parent.querySelectorAll('ol[data-page]')
    const nextPage = pages.length + 1
    const title = trans('recipes.page', {page: nextPage})

    sortable('ol.cmde_page', 'destroy')

    const $div = `<div class="col s4">
            <div class="card-panel">
                <h5>${title}</h5>
                <ol class="cmde_page" data-page="${nextPage}">
                </ol>
            </div>
        </div>`
    $(parent).append($div)

    initSortableCmde()
  })
}

// MAX_UPLOAD_SIZE is defined on webpack.mix.js
// eslint-disable-next-line no-undef
const max_size_allowed = 1024 * 1024 * MAX_UPLOAD_SIZE
Array.from(document.querySelectorAll('.check-size')).forEach(element => {
  element.onchange = function() {
    let must_alert = false
    for (const file of this.files) {
      if (file.size > max_size_allowed) {
        must_alert = true
        break
      }
    }
    if (must_alert) {
      this.value = ''
      showAlert(trans('terms.too_big_file'))
    }
  }
})

const changeCalculateReturnable = function() {
  if (
    false === $('#inform_returnable').is(':checked') &&
    $('#calculate_returnable').is(':checked')
  ) {
    $('#calculate_returnable').prop('checked', false)
  }
  $('#calculate_returnable')[
    $('#inform_returnable').is(':checked') ? 'removeAttr' : 'attr'
  ]('disabled', 'disabled')
}
const checkInvoiceUseDefaultCoordinates = function() {
  if ($('#invoice_use_default_coordinates').prop('checked')) {
    $('#invoice_coordinates_wrapper').slideUp()
  } else {
    $('#invoice_coordinates_wrapper').slideDown()
  }
}
const checkOrderMethod = function() {
  if ($('#order_method').val() === 'renew_order') {
    $('#renewable_days_wrapper').slideDown()
  } else {
    $('#renewable_days_wrapper').slideUp()
  }
}

const initClient = function() {
  const infoReturnable = document.querySelector('#inform_returnable')
  if (infoReturnable !== null) {
    infoReturnable.addEventListener('change', changeCalculateReturnable)
    changeCalculateReturnable()
  }

  const invoiceUseDefaultCoordinates = document.querySelector(
    '#invoice_use_default_coordinates'
  )
  if (invoiceUseDefaultCoordinates !== null) {
    invoiceUseDefaultCoordinates.addEventListener(
      'change',
      checkInvoiceUseDefaultCoordinates
    )
    checkInvoiceUseDefaultCoordinates()
  }

  const orderMethod = document.querySelector('#order_method')
  if (orderMethod !== null) {
    orderMethod.addEventListener('change', checkOrderMethod)
    checkOrderMethod()
  }
}

const initVehicleChoiceForm = function() {
  $('#vehicle-choice-form').submit(function(e) {
    const vehicle =
      typeof window.vehicles === 'undefined'
        ? null
        : window.vehicles[$('#tour_id').val()]
    const carrier =
      typeof window.carriers === 'undefined'
        ? null
        : window.carriers[$('#carrier_id').val()]

    let message = null
    if (vehicle === null && carrier === null) {
      return
    }

    if (carrier === null) {
      message = `${trans('deliveries.vehicle_choice_confirm', {
        vehicle,
      })}\n${trans('deliveries.start_tour_info')}`
    } else {
      message = `${trans('deliveries.vehicle_carrier_choice_confirm', {
        vehicle,
        carrier,
      })}\n${trans('deliveries.start_tour_info')}`
    }

    if (confirm(message)) {
      showLoading(true)
      return
    }
    e.preventDefault()
  })
}

const initRecipeForm = function() {
  const isPuffpastry = document.querySelector(
    '#is_puffpastry'
  )
  if (isPuffpastry !== null) {
    isPuffpastry.addEventListener(
      'change',
      checkIsPuffpastry
    )
    checkIsPuffpastry()
  }
}

const checkIsPuffpastry = function() {
  if ($('#is_puffpastry').prop('checked')) {
    $('#puffpastry_fields_wrapper').slideDown()
  } else {
    $('#puffpastry_fields_wrapper').slideUp()
  }
}

$('form[method="POST"]:not(.no-loading)').submit(() => {
  showLoading(true)
})

$(document).on('click', '.confirm-box', function(event) {
  if (confirm($(this).data('confirm-box-msg'))) {
    showLoading(true)

    const callbackData = $(this).data('confirm-callback')
    if (typeof callbackData !== 'undefined') {
      const callback = window[callbackData]
      if (typeof callback === 'function') {
        callback($(this).data('confirm-callback-data'))
      }
      showLoading(false)
    } else {
      return
    }
  }

  event.preventDefault()
})

$(document).on('keyup', 'input.float', function() {
  $(this).val(function(i, value) {
    return value.replace(/([^.0-9]+|[.]+)/g, '.').replace(/([.]+)/g, '.')
  })
})
$(document).on('focusout', 'input.float', function() {
  $(this).val(function(i, value) {
    var ini = value
    var val = value.replace(/([^.0-9]+|[.]+)/g, '.').replace(/([.]+)/g, '.').match(/^[0-9]+([.]{1}[0-9]+)?$/g)
    if(val == null){alert('Value "' + ini + '" not allowed')}
    return val
  })
})
